import { useRightColumnContext } from 'Context/RightColumnContext';
import React from 'react';
import ThreadHistoryDrawer
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHistoryPicker/ThreadHistoryDrawer';

const ThreadHistoryPicker = () => {
  const {
    showRightColumnCollection, rightColumnCollectionLoading,
  } = useRightColumnContext();

  if (!showRightColumnCollection || rightColumnCollectionLoading) {
    return null;
  }

  return <ThreadHistoryDrawer />;
};

export default ThreadHistoryPicker;
